<div class="ai-summary-content">
  <!-- Plan state not yet loaded -->
  <div *ngIf="!isPlanLoaded"
       class="d-flex align-items-center gap-2 text-muted py-2">
    <i class="far fa-spinner fa-spin"></i>
  </div>

  <!-- Subscribe state -->
  <div *ngIf="isPlanLoaded && !isSubscribed"
       class="ai-summary-subscribe">
    <div>
      <div class="ai-summary-subscribe-title"
           i18n>Subscribe to Artificial Intelligence</div>
      <div class="ai-summary-subscribe-copy" i18n>
        Generate guest history summaries and AI-powered booking context with Artificial Intelligence.
      </div>
    </div>
    <button type="button" class="btn btn-primary btn-sm" (click)="subscribeToTokeetAI()" i18n>Subscribe</button>
  </div>

  <ng-container *ngIf="isPlanLoaded && isSubscribed">
    <!-- Loading state -->
    <div *ngIf="isLoading"
         class="d-flex align-items-center gap-2 text-muted py-2">
      <i class="far fa-spinner fa-spin"></i>
      <span i18n>Generating summary...</span>
    </div>

    <!-- Error state -->
    <div *ngIf="!isLoading && error"
         class="ai-summary-empty">
      <i class="far fa-exclamation-circle mr-2"></i>
      <span>{{ error }}</span>
      <button type="button"
              class="btn btn-link btn-sm p-0 ml-2"
              (click)="loadSummary()"
              i18n>Retry</button>
    </div>

    <!-- No history / empty state -->
    <div *ngIf="!isLoading && !error && !summary"
         class="ai-summary-empty">
      <span i18n>No prior history available for this guest.</span>
    </div>

    <!-- Summary content -->
    <div *ngIf="!isLoading && !error && summary"
         class="ai-summary-body"
         [innerHTML]="summary"></div>
    </ng-container>
</div>
